import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { APIURL } from '../../../../Shared/Constant/API_Urls';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { UserService } from 'app/Shared/Services/user.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { ConstantService } from 'app/Shared/Services/constant-service';
import {CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { MatChipsModule } from '@angular/material/chips';
import { DrawerModule } from 'primeng/drawer';

@Component({
    selector: 'app-multileg-event',
    imports: [CommonModule, ButtonModule, MatTooltipModule, TableModule, MatExpansionModule,
        MatProgressSpinnerModule, ConfirmDialogModule,
        FormsModule, DialogModule, DatePipe, TooltipModule, DrawerModule, MatChipsModule],
    templateUrl: './multileg-event.component.html',
    styleUrls: ['./multileg-event.component.scss']
})

export class MultiLegEventComponent implements OnInit, OnDestroy{
  @Input() rowData: any;
  @Input() index!: number;
  @Input() showMultiLegEvent!: boolean;
  @Output() closeMultiLegEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  selectedRow: any = [];
  show: boolean =  true;
  selectedRowDetail!: any[];
  selectedColumns!: any[];
  multilegDetailDataset: any = [];
  tbldatamsg="No records found";
  isMultiLegDataSetLoading!: boolean;

  constructor(private sharedHttpClientService: SharedHttpClientService,
     public constantService: ConstantService,
     private urlService: UrlsService ,
     private userService: UserService,
    public date:DatePipe) {
  }

  async ngOnInit() {
    if (this.selectedRow.length <= 1) {
      this.selectedRow = [];
      this.selectedRow = (this.rowData);
      this.selectedRowDetail = [
        {'field': 'OrderID', 'value': this.rowData.orderID},
        {'field': 'Order Date', 'value': this.rowData.orderKeyDate},
        {'field': 'Underlying', 'value': this.rowData.underlying}
      ];
    }

    this.selectedColumns = [
      { header: "LegRefID", field: "legRefID", datatype: "String", display: "true" },
      { header: "Symbol", field: "symbol", datatype: "String", display: "true" },
      { header: "OptionID", field: "optionID", datatype: "String", display: "true" },
      { header: "Open/Close", field: "openCloseIndicator", datatype: "String", display: "true" },
      { header: "Side", field: "side", datatype: "String", display: "true" },
      { header: "Ratio", field: "legRatioQuantity", datatype: "String", display: "true" }
    ];

    this.getData();
  }

  getData() {
    this.isMultiLegDataSetLoading = true;

    const payload = {
      mpid: this.userService.getActiveMPID(),
      type: this.rowData.type,
      orderkeydate: this.userService.getyyyyMMddDateFormate(this.rowData.orderKeyDate),
      firmROEID: this.rowData.firmROEID
    };

    if(this.rowData.originalJSON) {
      let rawJson = JSON.parse(this.rowData.originalJSON);
      if(rawJson.legDetails && rawJson.legDetails.length > 0) {
        this.multilegDetailDataset = [];
        this.multilegDetailDataset = rawJson.legDetails;
        this.isMultiLegDataSetLoading = false;
      } else {
        this.multiLegDetailAPI(payload);
      }
    } else {
      this.multiLegDetailAPI(payload);
    }
  }

  multiLegDetailAPI(payload: any) {
    this.sharedHttpClientService.post(
      this.urlService.setAPIURl(
        APIURL.CAT_ROE_Viewer_MultiLegDetails
        ), payload)
    .subscribe({
      next: (result: any) => {
        this.isMultiLegDataSetLoading = false;
        let dataset: any = result;
        this.multilegDetailDataset = [];
        this.multilegDetailDataset = dataset.multilegList;
      },
      error: (err: HttpErrorResponse) => {
        this.isMultiLegDataSetLoading = false;
      }
    });
  }

  onClickClose(boolean: boolean | undefined) {
    this.closeMultiLegEvent.emit(boolean);
    this.show = false;
  }

  ngOnDestroy() {
  }
}
